import { useEffect } from 'react';
import ReactGA from 'react-ga4';

export default function usePageMeta(title, description, canonicalPath, schemaData = null, keywords = '') {
    const schemaString = schemaData ? JSON.stringify(schemaData) : '';

    useEffect(() => {
        // ── Title ────────────────────────────────────────────────
        document.title = title;

        const setMetaTag = (attrName, attrValue, content) => {
            let tag = document.querySelector(`meta[${attrName}="${attrValue}"]`);
            if (tag) {
                tag.setAttribute('content', content);
            } else {
                tag = document.createElement('meta');
                tag.setAttribute(attrName, attrValue);
                tag.setAttribute('content', content);
                document.head.appendChild(tag);
            }
        };

        // ── Meta Description ─────────────────────────────────────
        setMetaTag('name', 'description', description);

        // ── Keywords ─────────────────────────────────────────────
        if (keywords) {
            setMetaTag('name', 'keywords', keywords);
        } else {
            const existingKeywords = document.querySelector('meta[name="keywords"]');
            if (existingKeywords) existingKeywords.remove();
        }

        // ── Open Graph Tags ──────────────────────────────────────
        setMetaTag('property', 'og:site_name', 'Spinnennetz');
        setMetaTag('property', 'og:title', title);
        setMetaTag('property', 'og:description', description);
        setMetaTag('property', 'og:type', 'website');
        setMetaTag('property', 'og:image', 'https://thespinnennetz.com/spinnennetz-logo.png');

        // ── Twitter Card Tags ────────────────────────────────────
        setMetaTag('name', 'twitter:card', 'summary_large_image');
        setMetaTag('name', 'twitter:title', title);
        setMetaTag('name', 'twitter:description', description);
        setMetaTag('name', 'twitter:image', 'https://thespinnennetz.com/spinnennetz-logo.png');

        // ── Canonical URL ────────────────────────────────────────
        if (canonicalPath) {
            const canonicalHref = 'https://thespinnennetz.com' + (canonicalPath === '/' ? '' : canonicalPath);
            let canonical = document.querySelector('link[rel="canonical"]');
            if (canonical) {
                canonical.setAttribute('href', canonicalHref);
            } else {
                canonical = document.createElement('link');
                canonical.rel = 'canonical';
                canonical.href = canonicalHref;
                document.head.appendChild(canonical);
            }
            setMetaTag('property', 'og:url', canonicalHref);
        }

        // ── Structured Data (Schema) ─────────────────────────────
        if (schemaString) {
            let scriptTag = document.querySelector('script[id="page-schema"]');
            if (!scriptTag) {
                scriptTag = document.createElement('script');
                scriptTag.id = 'page-schema';
                scriptTag.type = 'application/ld+json';
                document.head.appendChild(scriptTag);
            }
            scriptTag.innerHTML = schemaString;
        } else {
            // Remove existing schema if no schema provided for this page
            const existingScript = document.querySelector('script[id="page-schema"]');
            if (existingScript) existingScript.remove();
        }

        // ── GA4 Pageview ─────────────────────────────────────────
        ReactGA.send({ hitType: 'pageview', page: canonicalPath || window.location.pathname, title });

        window.scrollTo(0, 0);
    }, [title, description, canonicalPath, schemaString, keywords]);
}
